import React from 'react'
import {Select, FormControl, InputLabel, MenuItem} from '@material-ui/core'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty, isUndefined} from 'lodash'
import {getTemplatesV2} from 'actions'
import IntlMessages from 'util/IntlMessages';

export default function MallInput(props) {
  const dispatch = useDispatch()

  const templates = useSelector(state => state.DocumentTempEditor.Templates)
  const auth = useSelector(state => state.auth.authUser)

  React.useEffect(() => {
    dispatch(getTemplatesV2(auth.user_Afid, auth.user_id))
  }, [])

  return (
    <FormControl variant="outlined" className={'w-100'}
      size="small">
      <InputLabel id="kategori-label" error={props.errorMall}><IntlMessages id="Template"/></InputLabel>
      <Select
        labelId="kategori-label"
        id="kategori"
        label={<IntlMessages id="Template"/>}
        name="orderBekraftelseMallId"
        onChange={props.onChange}
        value={!isUndefined(templates.filter(o => o.Type === 'Orderbekräftelse').find(t => t.id === props.orderBekraftelseMallId)) ? props.orderBekraftelseMallId : 0}
        error={props.errorMall}
      >
        <MenuItem value={0} disabled>
          <em><IntlMessages id="Choose"/></em>
        </MenuItem>
        {
          !isEmpty(templates) ?
          templates.filter(o => o.Type === 'Orderbekräftelse').map(m => {
            return(<MenuItem key={m.id} value={m.id}>{"("+m.Type + ") " + m.Name}</MenuItem>)
          }) : ''
        }
        
      </Select>
    </FormControl>
  )
}
